export function GameIcon({ name, size = 22 }: { name: string; size?: number }) {
  const paths: Record<string, React.ReactNode> = {
    rules: (
      <>
        <path d="M12 5C8 2 4 3 2 4v15c4-2 7-1 10 1 3-2 6-3 10-1V4c-4-2-7-1-10 1Z" />
        <path d="M12 5v15" />
      </>
    ),
    people: (
      <>
        <circle cx="9" cy="7" r="3" />
        <path d="M2 21v-3a7 7 0 0 1 14 0v3m0-17a3 3 0 0 1 0 6m3 4c2 1 3 3 3 7" />
      </>
    ),
    history: (
      <>
        <path d="M3 10a9 9 0 1 1 0 5M3 4v6h6m3-4v6l4 2" />
      </>
    ),
    cards: (
      <>
        <rect x="6" y="3" width="14" height="18" rx="3" />
        <path d="M3 6v13a3 3 0 0 0 3 3m4-10 3-3 3 3-3 3Z" />
      </>
    ),
    investigate: (
      <>
        <circle cx="10" cy="10" r="6" />
        <path d="m15 15 6 6" />
      </>
    ),
    "special-election": (
      <>
        <path d="m12 2 3 5 6 1-4 4 1 6-6-3-6 3 1-6-4-4 6-1Z" />
      </>
    ),
    execute: (
      <>
        <circle cx="12" cy="6" r="3" />
        <path d="M5 21v-3a7 7 0 0 1 14 0v3m-12-9 10 9" />
      </>
    ),
    peek: (
      <>
        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    veto: (
      <>
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path d="M8 10V6a4 4 0 0 1 8 0v4" />
      </>
    ),
    victory: (
      <>
        <path d="M7 3h10v6a5 5 0 0 1-10 0V3Zm5 11v6m-5 1h10M7 5H3v3a5 5 0 0 0 5 5m9-8h4v3a5 5 0 0 1-5 5" />
      </>
    ),
    liberal: (
      <>
        <path d="m3 14 7-2 4-8 2 6 5 2-7 2-4 6-1-5Z" />
      </>
    ),
    fascist: (
      <>
        <path d="M6 21V9h12v12M4 21h16M8 9V3h3v3h2V3h3v6M10 21v-5h4v5" />
      </>
    ),
    pin: (
      <>
        <path d="M12 22s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12Z" />
        <circle cx="12" cy="10" r="2.5" />
      </>
    ),
    check: <path d="m4 12 5 5L20 5" />,
    close: <path d="m5 5 14 14M5 19 19 5" />,
    pause: <path d="M9 5v14M15 5v14" />,
    next: <path d="m6 5 7 7-7 7M14 5v14" />,
    alert: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v6m0 3.5v.5" />
      </>
    ),
    strike: <path d="M4 12h16M8 6h8M8 18h8" />,
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name] ?? paths.cards}
    </svg>
  );
}
